import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors, FormControlLabel, Grid, IconButton, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { sto } from "../../../../Context/InshData";
import { Autocomplete } from "@material-ui/lab";
import {
    useStylesAutoPurch,
    useStylesLbl,
    useStylesAutoSafe,
    useStylesTF,
} from '../../../../St/Reports/UseStyle';
import { SaleCheckbox, useStylesAuto, useStylesUp } from "../../../../St/comps/UseStyle";
import { stElemnt } from "../../../../St/comps/cStyle";
import Delete from "@material-ui/icons/Delete";
import i18next from "i18next";
import { Info } from "@material-ui/icons";
import ItemDataDialog from "../models/ItemDataDialog";
import axios from "axios";
import { uri } from "../../../../help/Api";
import { CSVLink } from "react-csv";
import BarcodeGenrateCon from "../../../bascDatas/Tab1/items/barcodePrint/BarcodeGenrateCon";

const useStyles = makeStyles((theme) => ({
    table: {
        // minWidth: 650,
        minHeight: 500,
    },
}));
const barcodePrintValue = {
    sale: 0,
    barcode: '',
    item: {},
}
export default function InvItemsTable(props) {
    const { isdata, setIsData, maths, handSums,
        isPurches, isStock, isMake, permistionInv, handOSnack, setting, setConfirmDialog,
        isHedden, or, isOpenUpdate, setRowUpdate, mathsTab3val, AutoOptions, setAllowKeyboard, lastItem,
        setLastLtem, mathIdataIsharItem, valueIsharLevel, rowUpdate, post
    } = props;
    const [rowItem, setRowItem] = useState({});
    const [Found, setFound] = useState({});

    const handleFocus = (e) => e.target.select();
    let round = permistionInv?.ROUND == null ? 4 : permistionInv?.ROUND;


    const stylH = setting.PrTy_InPr === "03" ? stElemnt.SubHView : ["149", "150"].includes(setting.PrTy_InPr) ?
        { ...stElemnt.SubHView, backgroundColor: "#FF1493" } :
        isPurches ? stElemnt.SubHPruch : isStock ? stElemnt.SubHSafes : isMake ? stElemnt.SubHMake : stElemnt.SubHMu;
    const stylRo = stElemnt.SubR;

    const stylRo2 = {
        padding: "0px 0px",
        textAlign: "-webkit-center",
        margin: "0px",
        whiteSpace: "normal",
        BorderBottom: "solid 0.5px",
        fontSize: 12,
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
        width: "300px",
        maxWidth: "300px",
        minWidth: "200px",
        color: "#000"
    }
    const cellSD4 = {
        padding: "0px 0px",
        margin: "0px",
        fontSize: "0.7rem",
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word',
        direction: "rtl",
        textAlign: "right",
        width: "300px",
        minWidth: "200px",
        color: "#000"
    };
    const [infoData, setInfoData] = useState({ open: false, curr_id: 0, itemName: '', barcode: '', item: false });
    const [barcodeDialogOpen, setBarcodeDialogOpen] = useState(false);
    const [showAllDelete, setShowAllDelete] = useState(false);
    const [barodePrint, setBarodePrint] = useState(barcodePrintValue);
    const [menPostion, setMenuPostion] = useState(null);
    const [itemBarode, setBarcodeItem] = useState({});


    const calsPurch = useStylesAutoPurch();
    const claslbls = useStylesLbl();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasSaf = useStylesAutoSafe();
    const clasup = useStylesUp();
    const { t } = useTranslation(["forms"]);
    // const classes = useStyles();
    const onRowClick = (row) => {
        setRowUpdate(row);
        setAllowKeyboard(true);
    };
    const handleOpenUpdate = (props, e, row) => {
        setLastLtem(false);
        if (or.postput == "toPut" && !isOpenUpdate) return;
        if (["149", "150"].includes(setting.PrTy_InPr)
            && props !== "editIshar_amout" && props !== "editNewPrice_AfterIshar") return;
        if ((props === "editIshar_amout" || props === "editNewPrice_AfterIshar") && valueIsharLevel.id === 0) return;

        var newDataVal = isdata.filter((obj) => obj.editAbleVal === true);
        var newDataPrice = isdata.filter((obj) => obj.editAblePrice === true);
        var newDataUnit = isdata.filter((obj) => obj.editAbleUnit === true);
        var newDataTax = isdata.filter((obj) => obj.editAbleTax === true);
        var newDataDescM = isdata.filter((obj) => obj.editAbleDescM === true);
        var newDataDescP = isdata.filter((obj) => obj.editAbleDescP === true);
        var newDataNotes = isdata.filter((obj) => obj.editAbleDescNote === true);
        var newIshar_amout = isdata.filter((obj) => obj.editIshar_amout === true);
        var newNewPrice_AfterIshar = isdata.filter((obj) => obj.editNewPrice_AfterIshar === true);

        // console.log("the rowItem data inve is", rowItem);

        if (rowItem?.no != null) {
            if (rowItem.no == row.no) {
                if (newDataVal.length != 0 && props !== "editAbleVal") {
                    EnterChangeTtems("val1", rowItem, row);
                } else if (newDataPrice.length != 0 && props !== "editAblePrice") {
                    EnterChangeTtems("new_exchange_price", rowItem, row);
                } else if (newDataTax.length != 0 && props !== "editAbleTax") {
                    EnterChangeTtems("taxperc", rowItem, row);
                } else if (newDataDescM.length != 0 && props !== "editAbleDescM") {
                    EnterChangeTtems("discount", rowItem, row);
                } else if (newDataDescP.length != 0 && props !== "editAbleDescP") {
                    EnterChangeTtems("DiscPers", rowItem, row);
                }
                else if (newDataNotes.length != 0 && props !== "editAbleDescNote") {
                    EnterChangeTtems("notes", rowItem, row);
                }
                else if (newIshar_amout.length != 0 && props !== "editIshar_amout") {
                    EnterChangeTtems("Ishar_amout", rowItem, row);
                } else if (newNewPrice_AfterIshar.length != 0 && props !== "editNewPrice_AfterIshar") {
                    EnterChangeTtems("NewPrice_AfterIshar", rowItem, row);
                }
                else if (newDataUnit.length != 0 && props !== "editAbleUnit") {
                    EnterChangeTtems("val1", rowItem, row);
                    setRowItem({});
                }
            } else {
                if (newDataVal.length != 0) {
                    EnterChangeTtems("val1", rowItem, row);
                } else if (newDataPrice.length != 0) {
                    EnterChangeTtems("new_exchange_price", rowItem, row);
                } else if (newDataTax.length != 0) {
                    EnterChangeTtems("taxperc", rowItem, row);
                } else if (newDataDescM.length != 0) {
                    EnterChangeTtems("discount", rowItem, row);
                } else if (newDataDescP.length != 0) {
                    EnterChangeTtems("DiscPers", rowItem, row);
                }
                else if (newDataNotes.length != 0) {
                    EnterChangeTtems("notes", rowItem, row);
                }
                else if (newIshar_amout.length != 0) {
                    EnterChangeTtems("Ishar_amout", rowItem, row);
                } else if (newNewPrice_AfterIshar.length != 0 && props !== "editNewPrice_AfterIshar") {
                    EnterChangeTtems("NewPrice_AfterIshar", rowItem, row);
                }
                else if (newDataUnit.length != 0) {
                    EnterChangeTtems("val1", rowItem, row);
                    setRowItem({});
                }
            }
        } else {
            if (props === "editAbleVal") {
                var newData = isdata.filter((obj) => obj.editAbleVal === true);

                e.preventDefault();
                setRowItem({ ...row });
                const index = row?.no;
                const dataUpdate = [...isdata];
                dataUpdate[index] = {
                    ...row,
                    editAbleVal: or.postput == "toPost" ? true :
                        or.postput == "toPut" && isOpenUpdate ? true : false,
                };
                setIsData([...dataUpdate]);
            } else if (props === "editAblePrice") {
                e.preventDefault();
                setRowItem({ ...row });
                const index = row?.no;
                const dataUpdate = [...isdata];
                dataUpdate[index] = {
                    ...row,
                    editAblePrice: or.postput == "toPost" ? true :
                        or.postput == "toPut" && isOpenUpdate ? true : false,
                };
                setIsData([...dataUpdate]);
            }
            else if (props === "editAbleUnit") {
                if (row?.UnitsTable?.length > 1) {
                    e.preventDefault();
                    setRowItem({ ...row });
                    const index = row?.no;
                    const dataUpdate = [...isdata];
                    dataUpdate[index] = {
                        ...row,
                        editAbleUnit: or.postput == "toPost" ? true :
                            or.postput == "toPut" && isOpenUpdate ? true : false,
                    };
                    setIsData([...dataUpdate]);
                }
            } else if (props === "editAbleDescM") {
                e.preventDefault();
                setRowItem({ ...row });
                const index = row?.no;
                const dataUpdate = [...isdata];
                dataUpdate[index] = {
                    ...row,
                    editAbleDescM: or.postput == "toPost" ? true :
                        or.postput == "toPut" && isOpenUpdate ? true : false,
                };
                setIsData([...dataUpdate]);
            } else if (props === "editAbleDescP") {
                e.preventDefault();
                setRowItem({ ...row });
                const index = row?.no;
                const dataUpdate = [...isdata];
                dataUpdate[index] = {
                    ...row,
                    editAbleDescP: or.postput == "toPost" ? true :
                        or.postput == "toPut" && isOpenUpdate ? true : false,
                };
                setIsData([...dataUpdate]);
            } else if (props === "editAbleDescNote") {
                e.preventDefault();
                setRowItem({ ...row });
                const index = row?.no;
                const dataUpdate = [...isdata];
                dataUpdate[index] = {
                    ...row,
                    editAbleDescNote: or.postput == "toPost" ? true :
                        or.postput == "toPut" && isOpenUpdate ? true : false,
                };
                setIsData([...dataUpdate]);
            }
            else if (props === "editAbleTax") {
                e.preventDefault();
                setRowItem({ ...row });
                const index = row?.no;
                const dataUpdate = [...isdata];
                dataUpdate[index] = {
                    ...row,
                    editAbleTax: or.postput == "toPost" ? true :
                        or.postput == "toPut" && isOpenUpdate ? true : false,
                };
                setIsData([...dataUpdate]);
            } else {
                e.preventDefault();
                setRowItem({ ...row });
                const index = row?.no;
                const dataUpdate = [...isdata];
                dataUpdate[index] = {
                    ...row,
                    [props]: true,
                };
                setIsData([...dataUpdate]);
            }
        }

    };
    const changAutoCurrUnits = (row, newValue) => {

        let prc = setting.cusType == 1 ? newValue.sale : newValue.purch;
        let tot = (parseFloat(prc) * parseFloat(row.val1));
        let desc_mount = (
            parseFloat(tot) *
            (row.DiscPers / 100)
        );
        let totbef = (parseFloat(tot) - parseFloat(desc_mount));

        let taxMount = maths(
            parseFloat(totbef),
            parseFloat(row.taxperc),
            "taxval"
        );
        let betTax = maths(
            parseFloat(totbef),
            parseFloat(row.taxperc),
            "before_vat"
        );

        let resNetA = maths(
            parseFloat(totbef),
            parseFloat(row.taxperc),
            "Net"
        );
        let tot_before_vat_with_tab3val = 0;
        if (parseFloat(row?.tab3val_sub) > 0 && parseFloat(row.taxperc) > 0 && permistionInv?.USETOBACO) {
            let tot_before_new = maths(
                parseFloat(prc),
                parseFloat(row.taxperc),
                "before_vat"
            );
            tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                (parseFloat(25) * row.val1) : parseFloat(betTax).toFixed(2);

            let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

            taxMount = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(row.taxperc),
                "taxval"
            );

            resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                + parseFloat(taxMount)).toFixed(2);
        }
        let val1 = row.val1 == 0 ? 1 : row.val1;
        let itemType = Number(row?.type);

        let subInfoVal1_perc = row.val1 * newValue.perc;
        let countsCurr = parseInt(row?.Qtys ?? 0) - parseInt(val1);
        if (permistionInv.SIM == false &&
            countsCurr < subInfoVal1_perc && itemType != 4 &&
            (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
            const index = row?.no;
            const dontUpdateData = [...isdata];
            dontUpdateData[index] = {
                ...row,
                editAbleUnit: false,
            };
            setIsData([...dontUpdateData]);
            setRowItem({});
            handOSnack({
                vertical: "top",
                horizontal: "center",
                severit: "warning",
                text: "الكمية المدخلة للصنف أكبر من رصيد المخزن",
                time: 2000,
            });
        } else {
            const index = rowItem?.no;
            const dataUpdate = [...isdata];
            dataUpdate[index] = {
                ...rowItem,
                totJust: tot,
                totAfterDisc: betTax,
                taxval: taxMount,
                netAmountSub: resNetA,
                new_exchange_price: setting.cusType == 1 ? newValue.sale : newValue.purch,
                perc: newValue.perc,
                PricePu: newValue.purch,
                unitame: newValue.unitName,
                unit: newValue.unit,
                val: newValue.perc,
                defUnit: newValue,
                discount: desc_mount,
                tab3val_sub: tot_before_vat_with_tab3val,
                tab3Val: tot_before_vat_with_tab3val,
                editAbleUnit: false,
            };
            setIsData([...dataUpdate]);
            handSums(dataUpdate);
            setRowItem({});
        }
    };
    const handleDeleteRow = (e, row, isAll) => {
        e.preventDefault();
        if (isAll) {
            var newData = isdata.filter((obj) => obj.checkDelete !== true);
            const newItems = newData.map((row, i) => {
                return {
                    ...row,
                    no: i,
                };
            });
            setIsData([...newItems]);
            handSums(newData);
            setConfirmDialog(false);
            setRowItem({});
            setShowAllDelete(false);
        } else {
            var newData = isdata.filter((obj) => obj.no !== row.no);
            const newItems = newData.map((row, i) => {
                return {
                    ...row,
                    no: i,
                };
            });
            setIsData([...newItems]);
            handSums(newData);
            setConfirmDialog(false);
            setRowItem({});
        }


    };

    const MathChangIdataTtems = (prop, row) => (event) => {
        let i = {
            res: prop !== "notes" ? Number(event.target.value) : event.target.value,
            val1: Number(row.val1),
            val: Number(row.val),
            new_exchange_price: Number(row.new_exchange_price),
            totJust: Number(row.totJust),
            discount: Number(row.discount),
            DiscPers: Number(row.DiscPers),
            totAfterDisc: Number(row.totAfterDisc),
            taxperc: Number(row.taxperc),
            taxval: Number(row.taxval),
            netAmountSub: Number(row.netAmountSub),
            sale_price: Number(row.sale_price),
            PricePu: Number(row.PricePu),
            minPrice: Number(row.minPrice),
        };
        if (prop === "new_exchange_price") {
            let tot = parseFloat(i.res * i.val1);
            let desc_mount = (
                parseFloat(tot) *
                (i.DiscPers / 100)
            );
            let totBe = parseFloat((i.res * i.val1) - desc_mount);


            let taxMount = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "taxval"
            );
            let betTax = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "before_vat"
            );

            let resNetA = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "Net"
            );
            let tot_before_vat_with_tab3val = 0;
            if (parseFloat(row?.tab3val_sub) > 0 && parseFloat(i.taxperc) > 0 && permistionInv?.USETOBACO) {
                let tot_before_new = maths(
                    parseFloat(i.res),
                    parseFloat(i.taxperc),
                    "before_vat"
                );
                tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                    (parseFloat(25) * i.val1) : parseFloat(betTax).toFixed(2);

                let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

                taxMount = mathsTab3val(
                    parseFloat(tot_before),
                    parseFloat(i.taxperc),
                    "taxval"
                );

                resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                    + parseFloat(taxMount)).toFixed(2);
            }
            setRowItem({
                ...row,
                totJust: tot,
                new_exchange_price: event.target.value,
                totAfterDisc: betTax,
                taxval: taxMount,
                netAmountSub: resNetA,
                discount: desc_mount,
                tab3val_sub: tot_before_vat_with_tab3val,
                tab3Val: tot_before_vat_with_tab3val,
            });
        }
        else if (prop === "val1") {
            let val1 = i.res == 0 ? 1 : i.res;
            let tot = parseFloat(val1 * i.new_exchange_price);
            let desc_mount = (
                parseFloat(tot) *
                (i.DiscPers / 100)
            );
            let totBe = parseFloat((val1 * i.new_exchange_price) - desc_mount);

            let taxMount = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "taxval"
            );
            let betTax = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "before_vat"
            );

            let resNetA = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "Net"
            );
            let tot_before_vat_with_tab3val = 0;
            if (parseFloat(row?.tab3val_sub) > 0 && parseFloat(i.taxperc) > 0 && permistionInv?.USETOBACO) {
                let tot_before_new = maths(
                    parseFloat(i.new_exchange_price),
                    parseFloat(i.taxperc),
                    "before_vat"
                );
                tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                    (parseFloat(25) * i.res) : parseFloat(betTax).toFixed(2);

                let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

                taxMount = mathsTab3val(
                    parseFloat(tot_before),
                    parseFloat(i.taxperc),
                    "taxval"
                );

                resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                    + parseFloat(taxMount)).toFixed(2);
            }
            setRowItem({
                ...row,
                totJust: tot,
                totAfterDisc: betTax,
                taxval: taxMount,
                netAmountSub: resNetA,
                val1: event.target.value,
                discount: desc_mount,
                tab3val_sub: tot_before_vat_with_tab3val,
                tab3Val: tot_before_vat_with_tab3val,
            });

        }
        else if (prop === "discount") {

            let tot = parseFloat(i.new_exchange_price * i.val1);

            let totBe = parseFloat((i.new_exchange_price * i.val1) - i.res);

            let desc_perc = (
                (i.res * 100) /
                parseFloat(tot)
            );
            let taxMount = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "taxval"
            );
            let betTax = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "before_vat"
            );

            let resNetA = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "Net"
            );
            let tot_before_vat_with_tab3val = 0;
            if (parseFloat(row?.tab3val_sub) > 0 && parseFloat(i.taxperc) > 0 && permistionInv?.USETOBACO) {
                let tot_before_new = maths(
                    parseFloat(i.new_exchange_price),
                    parseFloat(i.taxperc),
                    "before_vat"
                );
                tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                    (parseFloat(25) * i.val1) : parseFloat(betTax).toFixed(2);

                let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

                taxMount = mathsTab3val(
                    parseFloat(tot_before),
                    parseFloat(i.taxperc),
                    "taxval"
                );

                resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                    + parseFloat(taxMount)).toFixed(2);
            }
            setRowItem({
                ...row,
                totJust: tot,
                totAfterDisc: betTax,
                taxval: taxMount,
                netAmountSub: resNetA,
                DiscPers: desc_perc,
                discount: event.target.value,
                tab3val_sub: tot_before_vat_with_tab3val,
                tab3Val: tot_before_vat_with_tab3val,
            });
        }
        else if (prop === "DiscPers") {

            let tot = parseFloat(i.new_exchange_price * i.val1);
            let desc_mount = (
                parseFloat(tot) *
                (i.res / 100)
            );
            let totBe = parseFloat((i.new_exchange_price * i.val1) - desc_mount);
            let taxMount = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "taxval"
            );
            let betTax = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "before_vat"
            );

            let resNetA = maths(
                parseFloat(totBe),
                parseFloat(i.taxperc),
                "Net"
            );
            let tot_before_vat_with_tab3val = 0;
            if (parseFloat(row?.tab3val_sub) > 0 && parseFloat(i.taxperc) > 0 && permistionInv?.USETOBACO) {
                let tot_before_new = maths(
                    parseFloat(i.new_exchange_price),
                    parseFloat(i.taxperc),
                    "before_vat"
                );
                tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                    (parseFloat(25) * i.val1) : parseFloat(betTax).toFixed(2);

                let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

                taxMount = mathsTab3val(
                    parseFloat(tot_before),
                    parseFloat(i.taxperc),
                    "taxval"
                );

                resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                    + parseFloat(taxMount)).toFixed(2);
            }
            setRowItem({
                ...row,
                totJust: tot,
                discount: desc_mount,
                totAfterDisc: betTax,
                taxval: taxMount,
                netAmountSub: resNetA,
                DiscPers: event.target.value,
                tab3val_sub: tot_before_vat_with_tab3val,
                tab3Val: tot_before_vat_with_tab3val,
            });


        }
        else if (prop === "taxperc") {


            let tot = parseFloat(i.new_exchange_price * i.val1);
            let desc_mount = (
                parseFloat(tot) *
                (i.DiscPers / 100)
            );
            let totBe = parseFloat((i.new_exchange_price * i.val1) - desc_mount);

            let taxMount = maths(
                parseFloat(totBe),
                parseFloat(i.res),
                "taxval"
            );
            let betTax = maths(
                parseFloat(totBe),
                parseFloat(i.res),
                "before_vat"
            );

            let resNetA = maths(
                parseFloat(totBe),
                parseFloat(i.res),
                "Net"
            );
            let tot_before_vat_with_tab3val = 0;
            if (parseFloat(row?.tab3val_sub) > 0 && parseFloat(i.res) > 0 && permistionInv?.USETOBACO) {
                let tot_before_new = maths(
                    parseFloat(i.new_exchange_price),
                    parseFloat(i.res),
                    "before_vat"
                );
                tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                    (parseFloat(25) * i.val1) : parseFloat(betTax).toFixed(2);

                let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

                taxMount = mathsTab3val(
                    parseFloat(tot_before),
                    parseFloat(i.res),
                    "taxval"
                );

                resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                    + parseFloat(taxMount)).toFixed(2);
            }
            setRowItem({
                ...row,
                totJust: tot,
                totAfterDisc: betTax,
                taxval: taxMount,
                netAmountSub: resNetA,
                taxperc: event.target.value,
                discount: desc_mount,
                tab3val_sub: tot_before_vat_with_tab3val,
                tab3Val: tot_before_vat_with_tab3val,
            });
        }
        else if (prop === "notes") {
            setRowItem({
                ...row,
                notes: event.target.value,
            });
        } else {
            setRowItem({
                ...row,
                [prop]: event.target.value,
            });
        }
    };

    const EnterChangeTtems = async (prop, rowItem, row) => {
        let i = {
            val1: Number(rowItem.val1),
            val: Number(rowItem.val),
            new_exchange_price: Number(rowItem.new_exchange_price),
            totJust: Number(rowItem.totJust),
            discount: Number(rowItem.discount),
            DiscPers: Number(rowItem.DiscPers),
            totAfterDisc: Number(rowItem.totAfterDisc),
            taxperc: Number(rowItem.taxperc),
            taxval: Number(rowItem.taxval),
            netAmountSub: Number(rowItem.netAmountSub),
            sale_price: Number(rowItem.sale_price),
            PricePu: Number(rowItem.PricePu),
            minPrice: Number(rowItem.minPrice),
        };
        if (prop === "new_exchange_price") {
            const index = rowItem?.no;
            const dataUpdate = [...isdata];

            let maxPrice = parseFloat(permistionInv?.MAXPRICE ?? 100000);

            if ((setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12" || setting.PrTy_InPr === "03") &&
                permistionInv.SNOP === true && rowItem != null &&
                parseFloat(i.new_exchange_price) < parseFloat(i.PricePu)) {
                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAblePrice: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: `لا يمكن البيع اقل من سعر الشراء للصنف سعر الشراء المسجل للصنف هو : 
                    ${row.PricePu}`,
                    time: 3000,
                });
            }
            else if ((setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12" || setting.PrTy_InPr === "03") &&
                parseFloat(i.new_exchange_price) > parseFloat(maxPrice)) {
                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAblePrice: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: `لقد تجاوزت حد السعر المسموح فيه... برجاء الذهاب لاعدادات النظام لزيادة الحد: 
                ${maxPrice}`,
                    time: 3000,
                });
            }
            else if ((setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12" || setting.PrTy_InPr === "03")
                && permistionInv.SNOMIN === 1 &&
                parseFloat(i.new_exchange_price ?? 0) < parseFloat(i.minPrice)) {
                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAblePrice: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: `لا يمكن البيع اقل من السعر الادنى للصنف السعر الادنى المسجل للصنف هو :  ${row.minPrice}`,
                    time: 3000,
                });
            } else if (parseFloat(i.new_exchange_price ?? 0) < 0 && !permistionInv.ASPZ) {
                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAblePrice: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: "لا يمكن البيع بسعر بقيمة سالبة ",
                    time: 3000,
                });
            }
            else if ((setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12") &&
                permistionInv.ASPZ === false && i.new_exchange_price <= 0) {
                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAblePrice: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: `لا يوجد لديك صلاحية البيع بسعر صفر `,
                    time: 3000,
                });
            }
            else if ((setting.PrTy_InPr == "01" || setting.PrTy_InPr == "11") &&
                permistionInv.ASPZ === false && i.new_exchange_price <= 0) {
                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAblePrice: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: `لا يوجد لديك صلاحية الشراء بسعر صفر `,
                    time: 3000,
                });
            }
            else {

                dataUpdate[index] = {
                    ...rowItem,
                    val1: rowItem.val1,
                    val: rowItem.val,
                    discount: rowItem.discount,
                    new_exchange_price: i.new_exchange_price,
                    DiscPers: rowItem.DiscPers,
                    taxperc: rowItem.taxperc,
                    editAblePrice: false,
                };
                setIsData([...dataUpdate]);
                handSums(dataUpdate);
                setRowItem({});
            }

        }
        else if (prop === "val1") {
            let val1 = i.val1 == 0 ? 1 : rowItem.val1;
            let subInfoVal1_perc = val1 * i.val;

            let totValbef = 0.0;
            for (let m = 0; m < isdata.length; m++) {
                if (row.currency_from == isdata[m].currency_from && row.no != isdata[m]?.no)
                    totValbef += (isdata[m].val1 * isdata[m].val);
            };
            let val = Number(row?.Qtys);
            let itemType = Number(row?.type);


            let countsCurr = parseInt(val ?? 0) - Number(totValbef);

            const index = rowItem?.no;
            const dataUpdate = [...isdata];
            let maxQty = parseFloat(permistionInv?.MAXQTY ?? 100000);

            if (permistionInv.SIM == false &&
                countsCurr < subInfoVal1_perc && itemType != 4 &&
                (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAbleVal: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: "الكمية المدخلة للصنف أكبر من رصيد المخزن",
                    time: 3000,
                });
            }
            else if ((setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12") &&
                parseFloat(rowItem.val1) > parseFloat(maxQty)) {
                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAbleVal: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: `لقد تجاوزت حد الكمية المسموح فيها... برجاء الذهاب لاعدادات النظام لزيادة الحد: 
                ${maxQty}`,
                    time: 3000,
                });
            }
            else if (rowItem.val1 < 0 || rowItem.val1 == 0) {
                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAbleVal: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: "لا يمكن ان تكون الكمية سالبة",
                    time: 3000,
                });
            }
            else {

                dataUpdate[index] = {
                    ...rowItem,
                    val1: val1,
                    val: rowItem.val,
                    discount: rowItem.discount,
                    new_exchange_price: i.new_exchange_price,
                    DiscPers: rowItem.DiscPers,
                    taxperc: rowItem.taxperc,
                    editAbleVal: false,
                };
                setIsData([...dataUpdate]);
                handSums(dataUpdate);
                setRowItem({});
            }


        }
        else if (prop === "discount") {

            if (permistionInv.APDC === 2 && permistionInv.DSOI == 1 &&
                (parseFloat(i.discount) > parseFloat(permistionInv.SDV)) ||
                parseFloat(i.discount) > parseFloat(rowItem.totJust)) {
                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAbleDescM: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: `
        لقد تجاوزت مبلغ الخصم المسموح بها
        مبلغ الخصم المسموح بة : ${parseFloat(permistionInv.SDV)
                        }
        `,
                    time: 3000,
                });
            }
            else {
                const index = rowItem?.no;
                const dataUpdate = [...isdata];
                dataUpdate[index] = {
                    ...rowItem,
                    val1: rowItem.val1,
                    val: rowItem.val,
                    discount: i.discount,
                    new_exchange_price: rowItem.new_exchange_price,
                    DiscPers: rowItem.DiscPers,
                    taxperc: rowItem.taxperc,
                    editAbleDescM: false,
                };
                setIsData([...dataUpdate]);
                handSums(dataUpdate);
                setRowItem({});
            }
        }
        else if (prop === "DiscPers") {

            if (permistionInv.APDC === 1 && permistionInv.DSOI == 1
                && parseFloat(i.DiscPers) > parseFloat(permistionInv.SDP)) {

                const index = rowItem?.no;
                const dontUpdateData = [...isdata];
                dontUpdateData[index] = {
                    ...row,
                    editAbleDescP: false,
                };
                setIsData([...dontUpdateData]);
                setRowItem({});
                handOSnack({
                    vertical: "top",
                    horizontal: "center",
                    severit: "warning",
                    text: `
                    لقد تجاوزت نسبة الخصم المسموح بها
                    نسبة الخصم المسموح بها : ${parseFloat(permistionInv.SDP)
                        }
                    `,
                    time: 3000,
                });
            }
            else {
                const index = rowItem?.no;
                const dataUpdate = [...isdata];
                dataUpdate[index] = {
                    ...rowItem,
                    val1: rowItem.val1,
                    val: rowItem.val,
                    discount: rowItem.discount,
                    new_exchange_price: rowItem.new_exchange_price,
                    DiscPers: i.DiscPers,
                    taxperc: rowItem.taxperc,
                    editAbleDescP: false,
                };
                setIsData([...dataUpdate]);
                handSums(dataUpdate);
                setRowItem({});
            }
        }
        else if (prop === "taxperc") {
            const index = rowItem?.no;
            const dataUpdate = [...isdata];
            dataUpdate[index] = {
                ...rowItem,
                val1: rowItem.val1,
                val: rowItem.val,
                discount: rowItem.discount,
                new_exchange_price: rowItem.new_exchange_price,
                DiscPers: rowItem.DiscPers,
                taxperc: i.taxperc,
                editAbleTax: false,
            };
            setIsData([...dataUpdate]);
            handSums(dataUpdate);
            setRowItem({});
        } else if (prop === "notes") {
            const index = rowItem?.no;
            const dataUpdate = [...isdata];
            dataUpdate[index] = {
                ...rowItem,
                val1: rowItem.val1,
                val: rowItem.val,
                discount: rowItem.discount,
                new_exchange_price: rowItem.new_exchange_price,
                DiscPers: rowItem.DiscPers,
                taxperc: i.taxperc,
                editAbleDescNote: false,
            };
            setIsData([...dataUpdate]);
            handSums(dataUpdate);
            setRowItem({});
        }
        else if (prop === "Ishar_amout_sub" || prop === "NewPrice_AfterIshar") {
            await mathIdataIsharItem(rowItem, row, setRowItem, prop);
        }
    };
    const containerRef = useRef(null);
    const handleClickInLine = (e, item) => {
        e.preventDefault();
        setMenuPostion({
            x: e.pageX,
            y: e.pageY,
            item: item,
            sale: Number(item?.sale_price),
        });
        setBarcodeItem({ ...item, tax: item?.taxperc });

    };

    //----------barcode-----------------
    const getBarcodeDataDialog = async () => {
        const tb = {
            wait: true,
            GetFoundation: true,
            parms: {
                branch: sto.branchi,
                ibranchid: sto.branchi,
                branch: sto.branchi,
                iFoundid: 1,
            },
        };

        axios
            .post(uri + "GetD", tb)
            .then((res) => {
                setFound(res.data);
                setBarodePrint({
                    ...barodePrint,
                    sale: parseFloat(menPostion?.sale ?? 0),
                    barcode: menPostion?.item?.barcode
                });
                if (res.data) {
                    setBarcodeDialogOpen(true);
                    setInfoData({ ...infoData, item: true });
                    console.log("the barcode is", menPostion)
                    handleClickOutLine();

                }
            })
            .catch((error) => {
            });
    };
    const menuBottons = () => {
        return (
            <ul
                style={{
                    position: "absolute",
                    top: menPostion.y,
                    left: menPostion.x,
                    background: "white",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    listStyle: "none",
                    padding: "5px 0",
                    boxShadow: "0px 2px 6px rgba(0,0,0,0.3)",
                    width: "150px"
                }}
            >
                <li
                    style={{
                        padding: "8px 12px",
                        cursor: "pointer",
                        borderBottom: "1px solid #eee"
                    }}
                    onClick={(e) => {
                        getBarcodeDataDialog();
                    }}

                >
                    {"Barcode Print"}
                </li>
                <li

                >
                    <CSVLink
                        separator={";"}
                        filename={excel_name}
                        data={isdata}
                        headers={excelHeaders}
                    >
                        {" "}{t("excel_export")}{" "}

                    </CSVLink>
                </li>

                <li
                    style={{
                        padding: "8px 12px",
                        cursor: "pointer",
                        borderBottom: "1px solid #eee",
                        color: colors.red[700],
                    }}
                    onClick={(e) => {
                        handleClickOutLine(e);
                    }}
                >
                    {"Cancel"}
                </li>
            </ul>
        );
    };
    const handleClickOutLine = () => {
        setMenuPostion(null);
    };

    //----------barcode-----------------

    useEffect(() => {
        if (containerRef.current && lastItem == true) {
            containerRef.current.scrollTop = containerRef.current.scrollHeight;
        }
    }, [isdata]);
    let excel_name = "InvoiceItems";

    const excelHeaders = [
        { label: "الباركود", key: "barcode", },
        { label: "الصنف", key: "symbol", },
        { label: "الوحدة", key: "unitame", },
        { label: "الكمية", key: "val1", },
        { label: "السعر", key: "new_exchange_price", },
        { label: "الاجمالي", key: "totJust", },
        { label: "قيمة الخصم", key: "discount", },
        { label: "الخصم%", key: "DiscPers", },
        { label: "الاجمالي قبل الضريبة", key: "totAfterDisc", },
        { label: "القيمة المضافة%", key: "taxperc", },
        { label: "إجمالي الضريبة", key: "taxval", },
        { label: "الصافي", key: "netAmountSub", },

    ];
    const checkDeleteItems = async (row, event) => {
        const index = row?.no;
        const dontUpdateData = [...isdata];
        dontUpdateData[index] = {
            ...row,
            checkDelete: event,
        };
        setIsData([...dontUpdateData]);
        var checkDelete = dontUpdateData.filter((obj) => obj.checkDelete === true);
        if (checkDelete?.length > 0) {
            setShowAllDelete(true);
        } else {
            setShowAllDelete(false);
        }

    }
    return (
        <Grid item container className={clasup.rootupMu}
        >
          {showAllDelete&&  <IconButton
                color="primary"
                aria-label="upload picture"
                style={{ maxHeight: "0.7rem" }}
                onClick={(e) => {
                    setConfirmDialog({
                        isOpen: true,
                        onConfirm: () => {
                            handleDeleteRow(e, {}, true);
                        },
                    })
                }}
            >
                <Delete size={"small"} />
            </IconButton>}
            <TableContainer component={Paper}            //className={classes.table} 
                style={{
                    minHeight: "22vw", maxHeight: "22vw", direction: i18next.language == "ar" ? "rtl" : "ltr"
                }}
                ref={containerRef}
            >
                <Table
                    size="small" aria-label="a dense table" >
                    <TableHead>
                        <TableRow
                            style={{
                                backgroundColor: isPurches ? colors.blue[300] : colors.green[300],
                                color: "#000",
                                border: "solid 0.6px"
                            }}
                        >
                            <TableCell style={stylH} align="center">
                                {""}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("barcode_number")}
                            </TableCell>

                            <TableCell style={stylH} align="center">
                                {t("item")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("unit")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("quanity")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("packaging")}
                            </TableCell>
                            {post == 2 ?
                                <TableCell style={stylH} align="center">
                                    {t("total-quantity")}
                                </TableCell>
                                :
                                <>
                                    <TableCell style={stylH} align="center">
                                        {t("price")}
                                    </TableCell>
                                    <TableCell style={stylH} align="center">
                                        {t("total")}
                                    </TableCell>

                                    <TableCell style={stylH} align="center">
                                        {t("discount_mount")}
                                    </TableCell>
                                    <TableCell style={stylH} align="center">
                                        {t("discount_perc")}
                                    </TableCell>
                                    <TableCell style={stylH} align="center">
                                        {t("total_after_discount")}
                                    </TableCell>
                                    <TableCell style={stylH} align="center">
                                        {t("tobacco_tax")}
                                    </TableCell>
                                    <TableCell style={stylH} align="center">
                                        {t("vat_perc")}
                                    </TableCell>
                                    <TableCell style={stylH} align="center">
                                        {t("vat_total")}
                                    </TableCell>
                                    <TableCell style={stylH} align="center">
                                        {t("net")}
                                    </TableCell>
                                </>}
                            {["149", "150"].includes(setting.PrTy_InPr) &&
                                <>
                                    <TableCell style={stylH} align="center">
                                        {"السعر الجديد"}
                                    </TableCell>
                                    <TableCell style={stylH} align="center">
                                        {"مبلغ الاشعار"}
                                    </TableCell>
                                    <TableCell style={stylH} align="center">
                                        {"اجمالي الاشعار"}
                                    </TableCell>
                                    <TableCell style={stylH} align="center">
                                        {"السعر بعد الاشعار"}
                                    </TableCell>
                                    <TableCell style={stylH} align="center">
                                        {"الضريبة بعد الاشعار"}
                                    </TableCell>
                                    <TableCell style={stylH} align="center">
                                        {"الصافي بعد الاشعار"}
                                    </TableCell>
                                    <TableCell style={stylH} align="center">
                                        {"ضريبة الاشعار"}
                                    </TableCell>
                                    <TableCell style={stylH} align="center">
                                        {"صافي الاشعار"}
                                    </TableCell>
                                </>
                            }
                            <TableCell style={stylH} align="center">
                                {t("note")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {""}
                            </TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isdata.map((row, i) => (
                            <TableRow key={row.i}
                                style={{
                                    padding: "5px 0px",
                                    textAlign: "-webkit-center",
                                    margin: "0px",
                                    whiteSpace: "nowrap",
                                    color: "#000",
                                    fontWeight: 600,
                                    fontFamily: "Amiri-Regular",
                                    fontSize: 12,
                                    border: "solid 0.6px"
                                }}
                            >
                                {/* <TableCell style={stylRo} align="center" >{row.no + 1}</TableCell> */}
                                <TableCell style={stylRo} align="center">
                                    <FormControlLabel
                                        id="showPaid"
                                        value="addProfSalary"
                                        name="showPaid"
                                        className={claslbl.clor}
                                        control={
                                            <SaleCheckbox
                                                checked={row.checkDelete}
                                                onChange={(e) => {
                                                    checkDeleteItems(row, e.target.checked);
                                                }}
                                                color={"#f18584"}
                                            />
                                        }
                                        label={row.no + 1}
                                        disabled={(or.postput == "toPut" && !isOpenUpdate) && ["149", "150"].includes(setting.PrTy_InPr)}
                                        labelPlacement="end"
                                    />
                                </TableCell>
                                <TableCell style={{ ...stylRo, backgroundColor: i === rowUpdate.no ? colors.blue[300] : "#fff" }} align="center" onClick={() => { onRowClick(row); }} >{row.barcode.toString()}</TableCell>
                                <TableCell style={stylRo2} align="center" onContextMenu={(e) => handleClickInLine(e, row)} onClick={() => { onRowClick(row); }} >{row.symbol}</TableCell>

                                <TableCell style={stylRo} align="center"
                                    onDoubleClick={(event) => handleOpenUpdate("editAbleUnit", event, row)}
                                >
                                    {
                                        row?.editAbleUnit && row?.UnitsTable?.length > 1 ? (
                                            <Autocomplete
                                                autoHighlight
                                                openOnFocus
                                                classes={isPurches ? calsPurch : isStock ? clasSaf : clasAo}
                                                value={row.defUnit}
                                                onChange={(event, newValue) => {
                                                    changAutoCurrUnits(row, newValue);
                                                }}
                                                id="combo-box-demo"
                                                options={row?.UnitsTable}
                                                getOptionLabel={(option) =>
                                                    typeof option === "string" ? option : option.unitName
                                                }
                                                onBlur={(e) => EnterChangeTtems("val1", rowItem, row)}
                                                disableClearable
                                                style={{ backgroundColor: colors.green[50] }}
                                                fullWidth
                                                variant="outlined"
                                                size="small"
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label={t("unit")}
                                                        variant="outlined"
                                                        InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                                    />
                                                )}

                                            />
                                        ) :
                                            (
                                                row.unitame
                                            )

                                    }
                                </TableCell>

                                <TableCell style={stylRo} align="center"
                                    onDoubleClick={(event) => handleOpenUpdate("editAbleVal", event, row)}
                                >
                                    {
                                        row.editAbleVal ?
                                            (
                                                <>
                                                    <TextField fullWidth
                                                        variant="outlined" size="small"
                                                        id="val1"
                                                        className={clasTF.rootSafe}
                                                        style={{ backgroundColor: colors.grey[50] }}
                                                        type="number"
                                                        name="val1"
                                                        onBlur={(e) => EnterChangeTtems("val1", rowItem, row)}
                                                        value={rowItem.val1}
                                                        onChange={MathChangIdataTtems("val1", row)}
                                                        autoFocus={true}
                                                        onFocus={handleFocus}
                                                        InputProps={{
                                                            className: claslbl.clrSafe,
                                                            onKeyDown: (event) => {
                                                                if (event.key === 'Enter') {
                                                                    EnterChangeTtems("val1", rowItem, row);
                                                                }
                                                            },
                                                            onBlur: () => {
                                                                EnterChangeTtems("val1", rowItem, row);
                                                            },
                                                        }}
                                                    />

                                                </>

                                            ) : (
                                                parseFloat(row.val1)?.toFixed(2)
                                            )}
                                </TableCell>
                                <TableCell style={stylRo} align="center"  > {row.val}</TableCell>
                                {post == 2 ?
                                    <TableCell style={stylRo} align="center"  > {parseFloat(row.val * row.val1).toFixed(2)}</TableCell> :
                                    <>
                                        <TableCell style={stylRo} align="center"
                                            onDoubleClick={(event) => handleOpenUpdate("editAblePrice", event, row)}
                                        >
                                            {
                                                row.editAblePrice && permistionInv.USP ?
                                                    (
                                                        <>

                                                            <TextField fullWidth variant="outlined" size="small"
                                                                id="new_exchange_price"
                                                                // label=" السعر"
                                                                className={clasTF.rootSafe}
                                                                style={{ backgroundColor: colors.grey[50], marginBlock: 5 }}
                                                                type="number"
                                                                name="new_exchange_price"
                                                                value={rowItem.new_exchange_price}
                                                                onChange={MathChangIdataTtems("new_exchange_price", row)}
                                                                autoFocus={true}
                                                                onFocus={handleFocus}
                                                                InputProps={{
                                                                    className: claslbl.clrSafe,
                                                                    onKeyDown: (event) => {
                                                                        if (event.key === 'Enter') {
                                                                            EnterChangeTtems("new_exchange_price", rowItem, row)
                                                                        }
                                                                    },
                                                                    onBlur: () => {
                                                                        EnterChangeTtems("new_exchange_price", rowItem, row)
                                                                    },
                                                                }}
                                                            />

                                                        </>

                                                    ) :
                                                    (
                                                        parseFloat(row.new_exchange_price)?.toFixed(round)
                                                    )}
                                        </TableCell>

                                        <TableCell style={stylRo} align="center"  > {parseFloat(row.totJust)?.toFixed(2)}</TableCell>
                                        <TableCell style={stylRo} align="center"
                                            onDoubleClick={(event) => handleOpenUpdate("editAbleDescM", event, row)}
                                        >
                                            {
                                                row.editAbleDescM && (permistionInv.APDC === 2 || permistionInv.APDC === 3)
                                                    && permistionInv.DSOI == 1 ?
                                                    (
                                                        <>
                                                            <TextField fullWidth variant="outlined" size="small"
                                                                id="discount"
                                                                className={clasTF.rootSafe}
                                                                style={{ backgroundColor: colors.grey[50], marginBlock: 5 }}
                                                                type="number"
                                                                name="discount"
                                                                value={rowItem.discount}
                                                                onChange={MathChangIdataTtems("discount", row)}
                                                                autoFocus={true}
                                                                onFocus={handleFocus}
                                                                InputProps={{
                                                                    className: claslbl.clrSafe,
                                                                    onKeyDown: (event) => {
                                                                        if (event.key === 'Enter') {
                                                                            EnterChangeTtems("discount", rowItem, row)
                                                                        }
                                                                    },
                                                                    onBlur: () => {
                                                                        EnterChangeTtems("discount", rowItem, row)
                                                                    },
                                                                }}
                                                            />

                                                        </>

                                                    ) : (
                                                        parseFloat(row.discount)?.toFixed(2)
                                                    )}
                                        </TableCell>

                                        <TableCell style={stylRo} align="center"
                                            onDoubleClick={(event) => handleOpenUpdate("editAbleDescP", event, row)}
                                        >
                                            {
                                                row.editAbleDescP && (permistionInv.APDC === 1 || permistionInv.APDC === 3) && permistionInv.DSOI == 1 ?
                                                    (
                                                        <>
                                                            <TextField fullWidth variant="outlined" size="small"
                                                                id="val1"
                                                                className={clasTF.rootSafe}
                                                                style={{ backgroundColor: colors.grey[50], marginBlock: 5 }}
                                                                type="number"
                                                                name="DiscPers"
                                                                value={rowItem.DiscPers}
                                                                onChange={MathChangIdataTtems("DiscPers", row)}
                                                                autoFocus={true}
                                                                onFocus={handleFocus}
                                                                InputProps={{
                                                                    className: claslbl.clrSafe,
                                                                    onKeyDown: (event) => {
                                                                        if (event.key === 'Enter') {
                                                                            EnterChangeTtems("DiscPers", rowItem, row)
                                                                        }
                                                                    },
                                                                    onBlur: () => {
                                                                        EnterChangeTtems("DiscPers", rowItem, row)
                                                                    },
                                                                }}
                                                            />

                                                        </>

                                                    ) : (
                                                        parseFloat(row.DiscPers)?.toFixed(4)
                                                    )}
                                        </TableCell>
                                        <TableCell style={stylRo} align="center"  > {parseFloat(row.totAfterDisc)?.toFixed(2) ?? "-"}</TableCell>
                                        <TableCell style={stylRo} align="center"  > {parseFloat(row.tab3Val)?.toFixed(2) ?? "-"}</TableCell>
                                        <TableCell style={stylRo} align="center"
                                            onDoubleClick={(event) => handleOpenUpdate("editAbleTax", event, row)}
                                        >
                                            {
                                                row.editAbleTax && permistionInv.SVU ?
                                                    (
                                                        <>
                                                            <TextField fullWidth variant="outlined" size="small"
                                                                id="taxperc"
                                                                className={clasTF.rootSafe}
                                                                style={{ backgroundColor: colors.grey[50], marginBlock: 5 }}
                                                                type="number"
                                                                name="taxperc"
                                                                value={rowItem?.taxperc}
                                                                onChange={MathChangIdataTtems("taxperc", row)}
                                                                autoFocus={true}
                                                                onFocus={handleFocus}
                                                                InputProps={{
                                                                    className: claslbl.clrSafe,
                                                                    onKeyDown: (event) => {
                                                                        if (event.key === 'Enter') {
                                                                            EnterChangeTtems("taxperc", rowItem, row)
                                                                        }
                                                                    },
                                                                    onBlur: () => {
                                                                        EnterChangeTtems("taxperc", rowItem, row)
                                                                    },
                                                                }}
                                                            />

                                                        </>

                                                    ) :
                                                    (
                                                        parseFloat(row.taxperc)?.toFixed(4)
                                                    )}
                                        </TableCell>
                                        <TableCell style={stylRo} align="center" >{row.taxval}</TableCell>
                                        <TableCell style={stylRo} align="center" >{row.netAmountSub}</TableCell>
                                    </>}
                                {["149", "150"].includes(setting.PrTy_InPr) &&
                                    <>
                                        <TableCell style={stylRo} align="center"  > {parseFloat(row?.Ishar_NewPrice ?? 0)?.toFixed(2) ?? "-"}</TableCell>
                                        <TableCell style={stylRo} align="center"
                                            onDoubleClick={(event) => handleOpenUpdate("editIshar_amout", event, row)}
                                        >
                                            {
                                                row.editIshar_amout && valueIsharLevel.id === 1 ?
                                                    (
                                                        <>
                                                            <TextField fullWidth variant="outlined" size="small"
                                                                id="Ishar_amout_sub"
                                                                className={clasTF.rootSafe}
                                                                style={{ backgroundColor: colors.grey[50], marginBlock: 5 }}
                                                                type="number"
                                                                name="Ishar_amout_sub"
                                                                value={rowItem?.Ishar_amout_sub}
                                                                onChange={MathChangIdataTtems("Ishar_amout_sub", row)}
                                                                autoFocus={true}
                                                                onFocus={handleFocus}
                                                                InputProps={{
                                                                    className: claslbl.clrSafe,
                                                                    onKeyDown: (event) => {
                                                                        if (event.key === 'Enter') {
                                                                            EnterChangeTtems("Ishar_amout_sub", rowItem, row)
                                                                        }
                                                                    },
                                                                    onBlur: () => {
                                                                        EnterChangeTtems("Ishar_amout_sub", rowItem, row)
                                                                    },
                                                                }}
                                                            />

                                                        </>

                                                    ) : (
                                                        parseFloat(row.Ishar_amout_sub ?? 0)?.toFixed(2)
                                                    )}
                                        </TableCell>

                                        <TableCell style={stylRo} align="center"  > {parseFloat(row.Ishar_amout_tot_sub ?? 0)?.toFixed(2) ?? "-"}</TableCell>
                                        {/* <TableCell style={stylRo} align="center"  > {parseFloat(row.NewPrice_AfterIshar ?? 0)?.toFixed(2) ?? "-"}</TableCell> */}
                                        <TableCell style={stylRo} align="center"
                                            onDoubleClick={(event) => handleOpenUpdate("editNewPrice_AfterIshar", event, row)}
                                        >
                                            {
                                                row.editNewPrice_AfterIshar && valueIsharLevel.id === 1 ?
                                                    (
                                                        <>
                                                            <TextField fullWidth variant="outlined" size="small"
                                                                id="NewPrice_AfterIshar"
                                                                className={clasTF.rootSafe}
                                                                style={{ backgroundColor: colors.grey[50], marginBlock: 5 }}
                                                                type="number"
                                                                name="NewPrice_AfterIshar"
                                                                value={rowItem?.NewPrice_AfterIshar}
                                                                onChange={MathChangIdataTtems("NewPrice_AfterIshar", row)}
                                                                autoFocus={true}
                                                                onFocus={handleFocus}
                                                                InputProps={{
                                                                    className: claslbl.clrSafe,
                                                                    onKeyDown: (event) => {
                                                                        if (event.key === 'Enter') {
                                                                            EnterChangeTtems("NewPrice_AfterIshar", rowItem, row)
                                                                        }
                                                                    },
                                                                    onBlur: () => {
                                                                        EnterChangeTtems("NewPrice_AfterIshar", rowItem, row)
                                                                    },
                                                                }}
                                                            />

                                                        </>

                                                    ) : (
                                                        parseFloat(row.NewPrice_AfterIshar ?? 0)?.toFixed(2)
                                                    )}
                                        </TableCell>
                                        <TableCell style={stylRo} align="center"  > {parseFloat(row.NewTax_AfterIshar ?? 0)?.toFixed(2) ?? "-"}</TableCell>
                                        <TableCell style={stylRo} align="center"  > {parseFloat(row.NewTot_AfterIshar ?? 0)?.toFixed(2) ?? "-"}</TableCell>
                                        <TableCell style={stylRo} align="center"  > {parseFloat(row.Ishar_Tax_sub ?? 0)?.toFixed(2) ?? "-"}</TableCell>
                                        <TableCell style={stylRo} align="center"  > {parseFloat(row.Ishar_amout_Net_sub ?? 0)?.toFixed(2) ?? "-"}</TableCell>
                                    </>
                                }
                                <TableCell style={cellSD4} align="center"
                                    onDoubleClick={(event) => handleOpenUpdate("editAbleDescNote", event, row)}
                                >
                                    {
                                        row.editAbleDescNote ?
                                            (
                                                <>
                                                    <TextField fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        id="notes"
                                                        className={clasTF.rootSafe}
                                                        style={{ ...cellSD4, backgroundColor: colors.grey[50] }}
                                                        type="text"
                                                        name="notes"
                                                        value={rowItem.notes}
                                                        onChange={MathChangIdataTtems("notes", row)}
                                                        autoFocus={true}
                                                        onFocus={handleFocus}
                                                        multiline
                                                        InputProps={{
                                                            className: claslbl.clrSafe,
                                                            onBlur: () => {
                                                                EnterChangeTtems("notes", rowItem, row)
                                                            },
                                                        }}
                                                    />

                                                </>

                                            ) : (
                                                row.notes
                                            )}
                                </TableCell>

                                <TableCell align="center" >
                                    {(or.postput === "toPost" ||
                                        (or.postput == "toPut" && isOpenUpdate)) && !["149", "150"].includes(setting.PrTy_InPr) &&
                                        (
                                            <IconButton
                                                color="primary"
                                                aria-label="upload picture"
                                                style={{ maxHeight: "0.7rem" }}
                                                onClick={(e) => {
                                                    setConfirmDialog({
                                                        isOpen: true,
                                                        onConfirm: () => {
                                                            handleDeleteRow(e, row, false);
                                                        },
                                                    })
                                                }}
                                            >
                                                <Delete size={"small"} />
                                            </IconButton>

                                        )
                                    }
                                    {!permistionInv?.HIDEITEMINFO &&
                                        (
                                            <IconButton
                                                color="primary"
                                                aria-label="upload picture"
                                                style={{ maxHeight: "0.7rem" }}
                                                onClick={(e) => {
                                                    console.log("the row", row);
                                                    setInfoData({ open: true, curr_id: row.currency_from, itemName: row.symbol, barcode: row.barcode })
                                                }}
                                            >
                                                <Info size={"small"} />
                                            </IconButton>
                                        )}

                                </TableCell>




                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {infoData.open &&
                <ItemDataDialog
                    infoData={infoData}
                    setInfoData={setInfoData}
                    PrTy_InPr={setting.PrTy_InPr}
                    isPurches={isPurches}
                    isStock={isStock}
                    isMake={isMake}
                    permistionInv={permistionInv}
                />
            }

            {menPostion && menuBottons()}

            {/* {infoData.item && barcodeDialogOpen ? (
                <BarcodeGenrateDialog
                    open={barcodeDialogOpen}
                    setOpen={setBarcodeDialogOpen}
                    data={itemBarode}
                    permiCuCo={permistionInv?.SALEVAT ?? true}
                    barcode={barodePrint.barcode}
                    sale_price={Number(barodePrint?.sale)}
                    AutoOptions={Found}
                />
            ) : null} */}

            {infoData.item && barcodeDialogOpen ? (
                <BarcodeGenrateCon
                    open={barcodeDialogOpen}
                    setOpen={setBarcodeDialogOpen}
                    data={itemBarode}
                    permiCuCo={permistionInv?.SALEVAT ?? true}
                    barcode={barodePrint.barcode}
                    sale_price={Number(barodePrint?.sale)}
                    AutoOptions={Found}
                    itemCom={[]}
                    type={itemBarode?.type ?? 1}
                />
            ) : null}

        </Grid>
    );
}
